<template>
  <div class="footer gridFooter">
    <div class="footer-left">
      <el-tooltip class="item" effect="dark" :content="(showLeftMenu?'隐藏':'显示') + '侧边栏'" placement="top">
        <div @click="handleShowLeftMenu" class="footer-btnicon tree-trigger">
          <i :class="{'icon-sideunfold': !showLeftMenu}" class="mng icon-sidefold"></i>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="导出" placement="top">
        <div class="footer-btnicon" @click="handleSelectExport"><i class="mng icon-export-stroke"></i></div>
      </el-tooltip>
      <el-tooltip v-if="showChartIcon" class="item" effect="dark" :content="showChart?'数据视图':'图表视图'" placement="top">
        <div @click="handleToggleChart" class="footer-btnicon tree-trigger">
          <i :class="{'icon-tree-data-stroke': showChart}" class="mng icon-bars-stroke"></i>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="删除记录" placement="top" v-if="isShowDeleteRecord">
        <div @click="toShowDeleteRecord" class="footer-btnicon tree-trigger"><i class="el-icon-time"></i></div>
      </el-tooltip>
    </div>
    <div class="tc">
      <div class="pg-wrap">
        <a
          @click="currentPageChange(1)"
          v-bind:class="{'btn-disabled': myCurPage <= 1}"
          href="javascript:" class="btn btn-hollow">首页</a>
        <a
          @click="currentPageChange(myCurPage - 1)"
          v-bind:class="{'btn-disabled': myCurPage <= 1}"
          href="javascript:" class="btn btn-hollow">上一页</a>
        <span class="pg-cur">第{{ myCurPage }}页</span>
        <a
          @click="currentPageChange(myCurPage + 1)"
          v-bind:class="{'btn-disabled': myCurPage >= totalPage}"
          href="javascript:" class="btn btn-hollow">下一页</a>
        <a
          @click="currentPageChange(totalPage)"
          v-bind:class="{'btn-disabled': myCurPage >= totalPage}"
          href="javascript:" class="btn btn-hollow">尾页</a>
      </div>
    </div>
    <div class="footer-right">
      <div class="pg-total">共{{ totalPage }}页&nbsp;&nbsp;&nbsp;&nbsp;{{ totalCount }}条</div>

      <div class="pg-select-wrap">
        <div class="pg-select" @click="showPageSizeSelect = !showPageSizeSelect">
          <i class="mng pg-select-arr" :class="[showPageSizeSelect ? 'icon-lineArrU-stroke' : 'icon-lineArrD-stroke']"></i>
          <div class="pg-select-result">显示{{ this.myPageSize }}条</div>
          <transition name="el-zoom-in-bottom">
          <div class="pg-select-list" v-show="showPageSizeSelect">
            <ul>
              <li v-for="item in pageSizeOpts"
                  v-bind:class="{'pg-select-cur': item === myPageSize}"
                  @click="pageSizeChange(item)"
                  class="pg-select-li">显示{{ item }}条
              </li>
            </ul>
          </div>
          </transition>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import {STORE_APP_MUTATION_TYPES} from '../../libs/constants'
  import util from '../../libs/util'

  export default {
    name: 'grid-footer',
    props: {
      curPage: { // 当前页
        type: Number,
        default: 1
      },
      pageSize: { // 页大小
        type: Number,
        default: 10
      },
      totalPage: { // 总页数
        type: Number,
        default: 1
      },
      totalCount: { // 记录总数
        type: Number,
        default: 0
      },
      pageSizeOpts: { // 每页条数切换配置
        type: Array,
        default() {
          return [10, 20, 50, 100]
        }
      },
      showChartIcon: {
        type: Boolean,
        default: false
      },
      showChart: {
        type: Boolean,
        default: false
      },
      gridConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      magicalMenuCodes: {
        type: Array,
        default() {
          return null
        }
      },
      showDeleteRecord: {
        type: Boolean,
        default () {
          return undefined
        }
      }
    },
    data() {
      return {
        showPageSizeSelect: false
      }
    },
    computed: {
      myCurPage: function () {
        return this.curPage
      },
      myPageSize: function () {
        return this.pageSize
      },
      showLeftMenu: function () {
        return this.$store.state.app.showLeftMenu
      },
      isShowDeleteRecord: function() {
        return this.showDeleteRecord !== undefined ? this.showDeleteRecord : this.magicalMenuCodes.indexOf('showDeleteRecord') >= 0
      }
    },
    methods: {
      // 当前页改变时
      currentPageChange(curPage) {
        curPage = curPage < 1 ? 1 : curPage
        curPage = curPage > this.totalPage ? this.totalPage : curPage
        this.$emit('current-change', curPage)
      },
      // 页大小改变时
      pageSizeChange(pageSize) {
        this.$emit('size-change', pageSize)
      },
      // 切换左侧菜单显示/隐藏
      handleShowLeftMenu() {
        this.$store.commit(STORE_APP_MUTATION_TYPES.SET_SHOW_LEFT_MENU, !this.showLeftMenu)
      },
      handleToggleChart() {
        this.$emit('toggle-chart')
      },
      // 点击导出按钮
      handleSelectExport() {
        this.$emit('export')
      },
      getNamespace: function(code) {
        let menus = this.gridConfig.gridMenuList
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].type === 'magicalMenu') {
            let extendConfig = JSON.parse(menus[i].extendMenuConfig)
            if (extendConfig.code === code) {
              return extendConfig.namespace
            }
          }
        }
        return null
      },
      toShowDeleteRecord: function() {
        util.changeRouter(this, {
          name: 'showDeleteRecord',
          query: {
            namespace: this.getNamespace('showDeleteRecord')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-footer.vue